<template>
  <div class="dashboard-title">
    <div class="dashboard-title__heading">
      <router-link v-if="backLink" :to="{ name: backLink }" class="dashboard-title__backlink">
        <ChevronLeft :size="20" />
      </router-link>
      <slot name="backLink" />

      <h1 class="dashboard-title__name">
        {{ title }}
      </h1>
      <slot />
    </div>
  </div>
</template>

<script>
import { ChevronLeft } from 'lucide-vue'

export default {
  components: {
    ChevronLeft,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    backLink: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.dashboard-title {
  &__heading {
    display: flex;
    align-items: center;
  }
  // Elements
  &__backlink {
    display: flex;
    align-items: center;
    color: $Black;
    font-size: 20px;
    margin-right: 8px;

    &:hover {
      text-decoration: none;
      color: $DGray;
    }
  }

  &__name {
    display: inline-block;
    font-weight: 800;
    font-size: calc(20px + 4 * ((100vw - 320px) / (1366 - 320)));
    line-height: calc(31 / 24);
    margin-bottom: 0;
  }
}
</style>
